/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelArCycleCode.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/ar-cycle-code";

export class AutogenModelArCycleCode<RowType extends ModelRow> extends Endpoint<RowType, RowArCycleCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowArCycleCode extends ModelRow<RowArCycleCodeFields> {
	constructor(values?: Partial<RowArCycleCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowArCycleCodeFields {
	company_id: string;
	days: number;
	days_method: string;
	descr: string;
	id: string;
}

